// 1-Projects/core4-masterclass/viewer/assets/mc-page.js
/* Core 4 Masterclass viewer: DOM glue. All decisions live in mc-core.js (window.MC). */
(function () {
  'use strict';
  const root = document.querySelector('[data-mc]');
  if (!root || !window.MC) return;
  const MC = window.MC;
  let cfg;
  try { cfg = JSON.parse(root.querySelector('script[data-mc-config]').textContent); } catch (e) { return; }

  const KEY = 'mc_v1';
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } };
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(store)); } catch (e) { /* storage blocked: degrade */ } };
  const store = load();
  store.played = store.played || {};
  store.watched = store.watched || [];

  const lessons = MC.sortLessons(cfg.lessons);
  const offerLesson = lessons.find(l => l.isOffer);
  const $all = sel => Array.from(root.querySelectorAll(sel));
  const lessonBtns = $all('[data-mc-lesson]');
  const bySrc = new Map(lessons.map(l => [l.src, l]));
  const btnFor = l => lessonBtns.find(b => Number(b.dataset.index) === l.src);
  // I1: buttons render in theme-editor order; put them in time order, renumber, hide any with a bad or duplicate time
  (function alignButtons() {
    const list = root.querySelector('.mc-lessons ol');
    lessonBtns.forEach(b => { if (!bySrc.has(Number(b.dataset.index))) b.closest('li').hidden = true; });
    lessons.forEach(l => {
      const b = btnFor(l);
      if (!b) return;
      const num = b.querySelector('.mc-num');
      if (num) num.textContent = String(l.index + 1);
      if (list) list.appendChild(b.closest('li'));
    });
  })();
  let player = null, duration = 0, lastT = null, lastSave = 0, curIdx = -1;

  // ---------- Klaviyo ----------
  const kl = () => window.klaviyo;
  // C1: Klaviyo's stub returns promises that never settle if klaviyo.js is blocked, so always race a timeout
  function identified() {
    const k = kl();
    if (!k || typeof k.isIdentified !== 'function') return Promise.resolve(false);
    let p;
    try { p = Promise.resolve(k.isIdentified()).then(Boolean, () => false); } catch (e) { return Promise.resolve(false); }
    return Promise.race([p, new Promise(r => setTimeout(() => r(false), 1500))]);
  }
  function track(name, props) {
    const k = kl();
    if (!k) return;
    identified().then(ok => {
      if (!ok) return;
      try { typeof k.track === 'function' ? k.track(name, props || {}) : k.push(['track', name, props || {}]); } catch (e) {}
    });
  }

  // ---------- Offer ----------
  function renderOffer() {
    const state = MC.offerState({ code: store.code, issuedAt: store.issuedAt, now: Date.now() });
    root.dataset.offer = state;
    if (state !== 'active') return;
    $all('[data-mc-code]').forEach(el => { el.textContent = store.code; });
    $all('[data-mc-claim]').forEach(a => { a.href = MC.discountUrl(store.code, cfg.bundlePath); });
    if (store.issuedAt) {
      const end = new Date(MC.expiresAt(store.issuedAt)).toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
      const left = MC.daysLeft(store.issuedAt, Date.now());
      $all('[data-mc-ends]').forEach(el => { el.textContent = `Ends ${end} · ${left} day${left === 1 ? '' : 's'} left`; });
    }
  }
  function setOfferOpen(open) {
    const head = root.querySelector('[data-mc-offer-toggle]'), body = root.querySelector('[data-mc-offer-body]');
    if (!head || !body) return;
    head.setAttribute('aria-expanded', String(open));
    body.hidden = !open;
  }
  // offer section reached (or reached before on this device): open the offer and give it a highlight
  function revealPanel() { const p = root.querySelector('[data-mc-panel]'); if (p) p.classList.add('is-featured'); setOfferOpen(true); }

  // ---------- Lessons ----------
  function paintLessons() {
    lessons.forEach(l => {
      const b = btnFor(l);
      if (!b) return;
      b.classList.toggle('is-current', l.index === curIdx);
      b.classList.toggle('is-watched', store.watched.includes(l.start));
    });
    const l = lessons[curIdx];
    const now = root.querySelector('[data-mc-now]');
    if (now) now.textContent = l ? `Section ${l.index + 1} of ${lessons.length} · ${l.title}` : '';
    const count = root.querySelector('[data-mc-count]');
    const done = lessons.filter(l => store.watched.includes(l.start)).length;
    if (count) count.textContent = `${done} of ${lessons.length} watched`;
    const bar = root.querySelector('[data-mc-progress]');
    if (bar) bar.style.width = lessons.length ? `${Math.round((done / lessons.length) * 100)}%` : '0';
  }


  // ---------- Section notes ----------
  // The panel follows playback; Previous/Next only browse the notes.
  const notesSrc = new Map($all('[data-mc-notes]').map(d => [Number(d.dataset.index), d.textContent]));
  let viewIdx = -1;
  function paintNotes(idx) {
    const body = root.querySelector('[data-mc-notes-body]');
    const l = lessons[idx];
    if (!body || !l || idx === viewIdx) return;
    viewIdx = idx;
    const title = root.querySelector('[data-mc-notes-title]');
    if (title) title.textContent = l.title;
    const pos = root.querySelector('[data-mc-notes-pos]');
    if (pos) pos.textContent = `· ${idx + 1} of ${lessons.length}`;
    body.innerHTML = MC.notesHtml(notesSrc.get(l.src) || '');
    body.scrollTop = 0;
    const prev = root.querySelector('[data-mc-notes-prev]'), next = root.querySelector('[data-mc-notes-next]');
    if (prev) prev.hidden = idx <= 0;
    if (next) next.hidden = idx >= lessons.length - 1;
  }
  const notesPanel = root.querySelector('[data-mc-notes-panel]');
  if (notesPanel) notesPanel.addEventListener('click', ev => {
    const ts = ev.target.closest('[data-seek]');
    if (ts) { seek(Number(ts.dataset.seek)); return; }
    if (ev.target.closest('[data-mc-notes-prev]')) paintNotes(Math.max(0, viewIdx - 1));
    if (ev.target.closest('[data-mc-notes-next]')) paintNotes(Math.min(lessons.length - 1, viewIdx + 1));
  });

  // ---------- Player ----------
  function onTime({ seconds: t, percent }) {
    if (lastT !== null && t > lastT && t - lastT < 2) {           // count only real playback, not seeks
      const i = MC.currentLesson(lessons, lastT);
      if (i >= 0) {
        const key = lessons[i].start;   // keyed by start time so stored progress survives lesson edits
        store.played[key] = (store.played[key] || 0) + (t - lastT);
        if (!store.watched.includes(key) && MC.isLessonWatched(store.played[key], lessons, i, duration)) store.watched.push(key);
      }
    }
    lastT = t;
    paintScrub(t);
    const idx = MC.currentLesson(lessons, t);
    if (idx !== curIdx) { curIdx = idx; paintLessons(); paintNotes(curIdx); }
    const pct = Math.round((percent || 0) * 100);
    MC.milestonesCrossed(store.maxPct || 0, pct).forEach(m => {
      if (m === 95) track('Masterclass Finished', {}); else track('Masterclass Progress', { percent: m });
    });
    store.maxPct = Math.max(store.maxPct || 0, pct);
    if (offerLesson && t >= offerLesson.start && !store.reachedOffer) {
      store.reachedOffer = true; revealPanel(); track('Masterclass Reached Offer', {});
    }
    store.pos = t;
    if (Date.now() - lastSave > 5000) { lastSave = Date.now(); save(); paintLessons(); }
  }

  function showResume() {
    const btn = root.querySelector('[data-mc-resume]');
    if (!btn || !store.pos || store.pos < 30 || (duration && store.pos > duration - 30)) return;
    const i = MC.currentLesson(lessons, store.pos);
    btn.textContent = `Continue where you left off (${MC.formatTime(store.pos)}${i >= 0 ? ', ' + lessons[i].title : ''})`;
    btn.hidden = false;
    btn.addEventListener('click', () => { seek(store.pos); btn.hidden = true; });
  }

  function seek(t) {
    if (!player) return;
    lastT = null;
    stage && stage.classList.add('has-started');
    paintScrub(t);
    // both calls go out inside the click's user gesture; chaining play() after the seek promise can lose it
    player.setCurrentTime(t).catch(() => {});
    player.play().catch(() => {});
  }

  function initPlayer() {
    const box = root.querySelector('[data-mc-player]');
    if (!box || !cfg.vimeoId || player) return;
    const iframe = document.createElement('iframe');
    // chromeless: Vimeo's UI is hidden and our branded bar drives the player (needs a paid Vimeo plan on the video's account)
    iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(cfg.vimeoId)}?controls=0&title=0&byline=0&portrait=0&badge=0&vimeo_logo=0&dnt=1&playsinline=1&autopause=0&color=5BC2E7`;
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = 'Core 4 Masterclass';
    box.appendChild(iframe);
    const fail = () => {
      box.innerHTML = '';
      const p = document.createElement('p');
      p.className = 'mc-fine';
      p.style.cssText = 'color:#fff;padding:24px';
      p.append('The video did not load. ');
      const a = document.createElement('a');
      a.href = `https://vimeo.com/${encodeURIComponent(cfg.vimeoId)}`; a.textContent = 'Watch it on Vimeo';
      a.style.color = '#fff'; a.target = '_blank'; a.rel = 'noopener';
      p.append(a); box.appendChild(p);
    };
    const start = () => {
      if (!window.Vimeo || !window.Vimeo.Player) { fail(); return; }
      player = new window.Vimeo.Player(iframe);
      player.getDuration().then(d => { duration = d; showResume(); drawTicks(); paintScrub(store.pos || 0); }).catch(fail);
      player.getTextTracks().then(tracks => {
        if (!tracks.length || !ccBtn) return;
        ccTrack = tracks[0];
        ccBtn.hidden = false;
      }).catch(() => {});
      player.on('timeupdate', onTime);
      player.on('play', () => {
        stage.classList.add('has-started', 'is-playing'); nudge();
        if (!store.started) { store.started = true; save(); track('Masterclass Started', {}); }
      });
      player.on('pause', () => { stage.classList.remove('is-playing', 'is-idle'); save(); });
      player.on('ended', () => { stage.classList.remove('is-playing', 'is-idle'); save(); });
    };
    if (window.Vimeo) start();
    else if (document.readyState === 'complete') fail();          // SDK blocked or failed: show the Vimeo link
    else window.addEventListener('load', start, { once: true });
  }

  // ---------- Branded controls ----------
  const stage = root.querySelector('[data-mc-stage]');
  const scrub = root.querySelector('[data-mc-scrub]');
  const fill = root.querySelector('[data-mc-fill]');
  const timeEl = root.querySelector('[data-mc-time]');
  const ccBtn = root.querySelector('[data-mc-cc]');
  let ccTrack = null, idleTimer = null;

  function paintScrub(t) {
    if (!duration) return;
    const pct = Math.max(0, Math.min(100, (t / duration) * 100));
    if (fill) fill.style.width = pct + '%';
    if (scrub) scrub.setAttribute('aria-valuenow', String(Math.round(pct)));
    if (timeEl) timeEl.textContent = `${MC.formatTime(t)} / ${MC.formatTime(duration)}`;
  }
  function drawTicks() {
    const box = root.querySelector('[data-mc-ticks]');
    if (!box || !duration) return;
    box.innerHTML = '';
    lessons.filter(l => l.start > 0 && l.start < duration).forEach(l => {
      const i = document.createElement('i');
      i.style.left = `${(l.start / duration) * 100}%`;
      i.title = l.title;
      box.appendChild(i);
    });
  }
  function togglePlay() {
    if (!player) return;
    player.getPaused().then(p => (p ? player.play() : player.pause())).catch(() => {});
  }
  function nudge() {   // show the bar on activity, hide it after 2.5s of stillness while playing
    if (!stage) return;
    stage.classList.remove('is-idle');
    clearTimeout(idleTimer);
    idleTimer = setTimeout(() => { if (stage.classList.contains('is-playing')) stage.classList.add('is-idle'); }, 2500);
  }
  function scrubTo(clientX) {
    if (!player || !duration || !scrub) return;
    const r = scrub.getBoundingClientRect();
    const t = Math.max(0, Math.min(1, (clientX - r.left) / r.width)) * duration;
    lastT = null;
    paintScrub(t);
    player.setCurrentTime(t).catch(() => {});
  }
  if (stage) {
    ['mousemove', 'touchstart', 'keydown'].forEach(ev => stage.addEventListener(ev, nudge, { passive: true }));
    const startBtn = root.querySelector('[data-mc-start]');
    if (startBtn) startBtn.addEventListener('click', () => {
      if (!player) return;
      stage.classList.add('has-started');
      if (store.pos && store.pos > 30 && (!duration || store.pos < duration - 30)) seek(store.pos);
      else player.play().catch(() => {});
    });
    const hit = root.querySelector('[data-mc-hit]');
    if (hit) hit.addEventListener('click', togglePlay);
    const tog = root.querySelector('[data-mc-toggle]');
    if (tog) tog.addEventListener('click', togglePlay);
    if (scrub) {
      let dragging = false;
      scrub.addEventListener('pointerdown', e => { dragging = true; scrub.setPointerCapture(e.pointerId); scrubTo(e.clientX); });
      scrub.addEventListener('pointermove', e => { if (dragging) scrubTo(e.clientX); });
      scrub.addEventListener('pointerup', () => { dragging = false; });
      scrub.addEventListener('keydown', e => {
        if (!player || !duration) return;
        const step = e.key === 'ArrowRight' ? 10 : e.key === 'ArrowLeft' ? -10 : 0;
        if (!step) return;
        e.preventDefault();
        player.getCurrentTime().then(t => { const n = Math.max(0, Math.min(duration, t + step)); lastT = null; paintScrub(n); player.setCurrentTime(n); });
      });
    }
    if (ccBtn) ccBtn.addEventListener('click', () => {
      if (!player || !ccTrack) return;
      const on = ccBtn.getAttribute('aria-pressed') === 'true';
      (on ? player.disableTextTrack() : player.enableTextTrack(ccTrack.language, ccTrack.kind))
        .then(() => ccBtn.setAttribute('aria-pressed', String(!on))).catch(() => {});
    });
    const fs = root.querySelector('[data-mc-fs]');
    if (fs) fs.addEventListener('click', () => {
      if (document.fullscreenElement) { document.exitFullscreen(); return; }
      if (stage.requestFullscreen) stage.requestFullscreen().catch(() => player && player.requestFullscreen());
      else if (player) player.requestFullscreen().catch(() => {});   // iPhone: native video fullscreen
    });
  }

  // ---------- Access ----------
  function unlock() {
    root.dataset.access = 'unlocked';
    document.documentElement.classList.remove('mc-locked');
    store.unlocked = true; save();
    curIdx = Math.max(0, MC.currentLesson(lessons, store.pos || 0));
    renderOffer();
    if (store.reachedOffer) revealPanel();
    paintLessons();
    paintNotes(curIdx);
    initPlayer();
  }

  // ---------- Gate form (Klaviyo Client Subscriptions API) ----------
  const form = root.querySelector('[data-mc-gate-form]');
  if (form) form.addEventListener('submit', e => {
    e.preventDefault();
    const email = (form.querySelector('input[type=email]').value || '').trim();
    const msg = root.querySelector('[data-mc-gate-msg]');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Please enter a valid email.'; return; }
    msg.textContent = 'Opening the class...';
    const btn = form.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;
    const body = { data: { type: 'subscription', attributes: {
      custom_source: cfg.source,
      // posting to the list is the email-marketing consent; the client endpoint rejects a 'subscriptions' field
      profile: { data: { type: 'profile', attributes: { email } } } },
      relationships: { list: { data: { type: 'list', id: cfg.klaviyoListId } } } } };
    fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(cfg.klaviyoPublicKey)}`, {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify(body),
    }).then(r => {
      if (r.status >= 400 && r.status < 500) throw new Error('status ' + r.status);   // bad email or bad config
      // 2xx, or a Klaviyo 5xx: let them watch; losing one sign-up beats blocking a willing viewer
      try { const k = kl(); if (k && typeof k.identify === 'function') k.identify({ email }); } catch (err) {}
      msg.textContent = '';
      unlock();
    }).catch(err => {
      if (btn) btn.disabled = false;
      if (err instanceof TypeError) { msg.textContent = ''; unlock(); return; }   // network/blocked request: still unlock
      msg.textContent = 'Something went wrong. Please check your email address, or email support@aspirenutrition.com.';
    });
  });

  // ---------- Clicks ----------
  const offerToggle = root.querySelector('[data-mc-offer-toggle]');
  if (offerToggle) offerToggle.addEventListener('click', () => {
    const open = offerToggle.getAttribute('aria-expanded') !== 'true';
    setOfferOpen(open);
    if (open) track('Masterclass Offer Opened', {});
  });
  lessonBtns.forEach(b => b.addEventListener('click', () => {
    const l = bySrc.get(Number(b.dataset.index));
    if (l) seek(l.start);
  }));
  $all('[data-mc-copy]').forEach(b => b.addEventListener('click', () => {
    const value = b.dataset.copyValue || store.code;
    if (!value) return;
    const act = b.querySelector('.mc-chip-act') || b;
    const done = () => { act.textContent = 'Copied'; setTimeout(() => { act.textContent = 'Copy'; }, 1500); };
    if (navigator.clipboard) navigator.clipboard.writeText(value).then(done).catch(() => {});
  }));
  $all('[data-mc-claim]').forEach(a => a.addEventListener('click', () => track('Masterclass Claim Clicked', { offer: 'bundle20' })));
  $all('[data-mc-claim-singles]').forEach(a => a.addEventListener('click', () => track('Masterclass Claim Clicked', { offer: 'singles10' })));
  $all('[data-mc-ebook]').forEach(a => a.addEventListener('click', () => track('Masterclass Ebook Downloaded', {})));

  // ---------- Boot ----------
  const params = MC.parseParams(window.location.search);
  const boot = isId => {
    const a = MC.resolveAccess({ params, stored: store, identified: isId, now: Date.now() });
    store.code = a.code; store.issuedAt = a.issuedAt;
    if (a.unlocked) unlock();
    else {
      root.dataset.access = 'locked'; renderOffer();
      document.documentElement.classList.add('mc-locked');   // full-screen gate: stop the page scrolling behind it
      const input = root.querySelector('#mc-email'); if (input) input.focus({ preventScroll: true });
    }
  };
  if (MC.quickAccess({ params, stored: store })) boot(false);   // link or device: unlock now, no Klaviyo wait
  else identified().then(boot);
})();
